import { render, staticRenderFns } from "./WhatsappPartnerTariff.vue?vue&type=template&id=64b64514&"
import script from "./WhatsappPartnerTariff.vue?vue&type=script&lang=ts&"
export * from "./WhatsappPartnerTariff.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports